import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations(['setDeviceWidth', 'setDeviceHeight']),
    watchResize () {
      this.setSize()

      this.$nextTick(() => {
        window.addEventListener('resize', this.setSize)
      })
    },
    setSize () {
      this.setDeviceWidth(window.innerWidth)
      this.setDeviceHeight(window.innerHeight)
    }
  },
  mounted () {
    this.watchResize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setSize)
  }
}
